import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Zona horaria de Argentina para pedidos (backend envía fechas con offset -03:00). */
export const ORDER_TIMEZONE = "America/Argentina/Buenos_Aires";

/**
 * Configuración de fechas para pedidos de agencias.
 * El backend devuelve fechas en ISO 8601 con offset -03:00 (Argentina).
 * No se convierte a UTC ni se suman/restan horas: se muestra tal cual viene.
 */
export const ORDER_DATE_CONFIG = {
  /** Formato de fecha y hora en pantalla: DD/MM/YYYY HH:mm */
  DISPLAY_FORMAT: "DD/MM/YYYY HH:mm",
};

/**
 * Formatea una fecha de pedido para mostrar en listados y detalle.
 * Parsea el string ISO 8601 con offset (ej. "2026-02-18T02:01:05-03:00"),
 * respeta la zona Argentina y muestra la hora tal cual la envía el backend.
 *
 * @param {string} dateString - Fecha en ISO 8601 con offset (ej. "2026-02-18T02:01:05-03:00")
 * @returns {string} Fecha formateada (ej. "18/02/2026 02:01") o "-" si no hay valor
 */
export function formatOrderDate(dateString) {
  if (!dateString) return "-";
  try {
    const fecha = dayjs(dateString);
    if (!fecha.isValid()) return dateString;
    const { DISPLAY_FORMAT } = ORDER_DATE_CONFIG;
    return fecha.tz(ORDER_TIMEZONE).format(DISPLAY_FORMAT);
  } catch {
    return dateString;
  }
}
